<!--
    Component Game
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content" v-if="activeGame == null"> 
			<div class="bar darkText largeText">
				<div class="gridLabel bg-timeline">{{ model.getDictionary('nav_game')}}</div>
			</div>

			<div class="game-grid">
				<div class="game-game link" @click="selectGame('memory');">
					<div class="game-game-image zoomable">
						<img src='../assets/game_memory.webp' />
					</div>
					<div class="game-game-label">{{ model.getDictionary('game_memory') }}</div>
				</div>
				<div class="game-game link" @click="selectGame('artist')">
					<div class="game-game-image zoomable">
						<img src='../assets/game_artist.webp' />
					</div>
					<div class="game-game-label">{{ model.getDictionary('game_artist') }}</div>
				</div>
				<div class="game-game link" @click="selectGame('technique')">
					<div class="game-game-image zoomable">
						<img src='../assets/game_style.webp' />
					</div>
					<div class="game-game-label">{{ model.getDictionary('game_technique') }}</div>
				</div>
				<div class="game-game link" @click="selectGame('time')">
					<div class="game-game-image zoomable">
						<img src='../assets/game_timesort.webp' />
					</div>
					<div class="game-game-label">{{ model.getDictionary('game_time') }}</div>
				</div>
			</div>
		</div>

		<game-memory v-if="activeGame == 'memory'" ref='gameMemory'></game-memory>
		<game-artist v-if="activeGame == 'artist'" ref='gameArtist'></game-artist>
		<game-technique v-if="activeGame == 'technique'" ref='gameTechnique'></game-technique>
		<game-time v-if="activeGame == 'time'" ref='gameTime'></game-time>

	</div>
</template>

<script>

	import { linkBaseURL } from './../model/config.js'
	import { model } from "./../model/Model.js";

	import GameMemory from './GameMemory.vue';
	import GameArtist from './GameArtist.vue';
	import GameTechnique from './GameTechnique.vue';
	import GameTime from './GameTime.vue';

	export default {

		components: { GameMemory, GameArtist, GameTechnique, GameTime },

		data: function() {
			return {

				// which game is active
				activeGame: null,

				// expose the model for translations
				model: model,

				// all available elements
				list: model.getDocument(),
				baseURL: linkBaseURL
			};
		},

		methods: {
			selectGame: function(game) {
				this.activeGame = game;
			},
			closeGame: function() {
				this.activeGame = null;
			}			
		}
	}

</script>


<style>

	div.spaceAbove {
		margin-top: 2rem;
	}

	div.game-grid {
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	div.game-game {
		width: 20rem;
		margin-bottom: 2rem;
		margin-right: 2rem;
	}

	div.game-game-image {
		width: 20rem;
		height: 10rem;
		overflow: hidden;
	}

	div.game-game-image img, div.game-game-image div {
		object-fit: cover;
		object-position: center;
		width: 20rem;
		height: 10rem;
	}

	div.game-game-label {
		font-size: 1rem;
		color: white;
		background-color: #92a8b4;
		padding: 0.3rem 2.4rem 0.3rem 2.4rem;
	}	

</style>